export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Registration success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["登録が完了しました"])}
    }
  })
}
